import type { AppTableState } from 'shared/UI/UIKit/Table';
import type { ClassGroupFilters, ClassGroupsRequest } from 'shared/api';

export const getClassGroupsRequest = (
  tableState: AppTableState,
  filterState: ClassGroupFilters,
): ClassGroupsRequest => ({
  page: (tableState.pagination.current || 1) - 1,
  size: tableState.pagination.pageSize || 10,
  sort: tableState.sorters
    .filter(({ order }) => order)
    .map(({ dataIndex, order }) => {
      const property = dataIndex.join('.');
      const apiProperty = property === 'teacherId' ? 'teacherWorkload.id' : property;

      return `${apiProperty},${order === 'ascend' ? 'asc' : 'desc'}`;
    }),
  ...filterState,
});
